<template>
  <div>
    <b-form-group label="Status" label-for="landing-status">
      <multi-select
        id="landing-status"
        :select-options="statuses"
        v-model="status"
        btn-label="Choose status"
        size="lg"
      />
    </b-form-group>
    <div v-if="toReject" class="mb-3">
      <b-form-group label="Reject reason" label-for="reject-reasons">
        <multi-select
          id="reject-reasons"
          :search="rejectReasons.length > 9"
          :select-options="rejectReasons"
          v-model="rejectionReason.reason"
          btn-label="Choose Creative format"
          size="lg"
        />
      </b-form-group>
      <b-form-textarea
        id="description"
        v-model="rejectionReason.description"
        placeholder="Rejection reason description"
        :disabled="isDisabledDescription"
        size="lg"
      />
    </div>
    <div>
      <button class="btn btn-sm btn-primary float-right" @click="submit()">
        Change status
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupId: {
      type: [Number, null],
      default: null
    },
    landing: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      rejectionReason: {
        description: null,
        reason: [
          {
            id: 0,
            name: 'Custom reason'
          }
        ]
      },
      rejectReasons: [
        {
          id: 0,
          name: 'Custom reason'
        },
        {
          id: 1,
          name: 'Broken link'
        },
        {
          id: 2,
          name: 'Illegal content'
        }
      ],
      status: [],
      statuses: ['approved', 'rejected'],
      form: {
        id: this.landing.id,
        landingGroupId: this.groupId
      }
    };
  },

  computed: {
    toReject() {
      return this.status[0] === 'rejected';
    },
    isDisabledDescription() {
      return this.rejectionReason.reason[0].id !== 0;
    }
  },

  watch: {
    'rejectionReason.reason': {
      immediate: true,
      handler() {
        console.log;
        this.rejectionReason.description =
          this.rejectionReason.reason[0].id === 0
            ? null
            : this.rejectionReason.reason[0].name;
      }
    }
  },

  methods: {
    getReasonById(id) {
      return this.rejectReasons.filter(reason => reason.id === id);
    },
    submit() {
      const status = this.status[0] === 'rejected' ? 'reject' : 'approve';
      const landingModel = {
        id: this.landing.id,
        landingGroupId: this.groupId
      };

      if (status === 'reject') {
        landingModel.reason = this.rejectionReason.reason[0].id;
        landingModel.description = this.rejectionReason.description;
      }

      this.$api.adnet
        .put(`/dsp/landings/${status}/${landingModel.id}`, landingModel)
        .then(
          () => {
            this.$notify('alert', {
              text: `Landing status - ID ${landingModel.id} - updated.`,
              variant: 'danger',
              time: 5000
            });
            this.$emit('update-landings');
          },
          e => {
            e.response.data.detail &&
              this.$notify('alert', {
                text: e.response.data.detail,
                variant: 'danger',
                time: 0
              });
          }
        );
    }
  },

  created() {
    this.status =
      this.landing.status === 'pending' ? ['approved'] : [this.landing.status];
    if (this.landing.status === 'rejected') {
      const reasonType = this.getReasonById(
        parseInt(this.landing.rejectReason)
      );
      this.rejectionReason.reason = reasonType;
      if (reasonType[0].id === 0)
        this.rejectionReason.description = this.landing.rejectDescription;
    }
  }
};
</script>
